import Paziente from "./pages/PazienteMain.vue";

export default {
    Paziente,
};
